<div
  class="slider"
  #slideInteraction
  (mouseenter)="pauseAutoSlideOnHover && pauseAutoplay($event)"
  (mouseleave)="pauseAutoSlideOnHover && startAutoPlay($event)"
  >
  <div class="slider-body-wrapper">
    <ng-content></ng-content>
  </div>
</div>
@if (hasPointNav) {
  <div class="slider-nav">
    <div class="wrap">
      @for (tab of _items; track tab; let i = $index) {
        <a
          (click)="changeSlide(i); clearAutoSlide()"
          [ngClass]="{ active: selectedIndex === i }"
        ></a>
      }
    </div>
  </div>
}
@if (hasArrowNav) {
  <div class="arrow-nav">
    @if (selectedIndex > 0) {
      <button
        class="arrow prev"
        (click)="changeSlide('prev')"
        (mouseenter)="pauseAutoSlideOnHover && pauseAutoplay($event)"
        (mouseleave)="pauseAutoSlideOnHover && startAutoPlay($event)"
        >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" [attr.fill]="arrowIconColor" />
            <path d="M0 0h24v24H0V0z" fill="none" />
          </svg>
        </span>
      </button>
    }
    <button
      class="arrow next"
      (click)="changeSlide('next')"
      (mouseenter)="pauseAutoSlideOnHover && pauseAutoplay($event)"
      (mouseleave)="pauseAutoSlideOnHover && startAutoPlay($event)"
      >
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" [attr.fill]="arrowIconColor" />
          <path d="M0 0h24v24H0V0z" fill="none" />
        </svg>
      </span>
    </button>
  </div>
}
